import { PathEnum } from '@/i18n/locale-config';
import { Link } from '@/i18n/navigation';
import { FilterUrlParamEnum } from '@/types/enums';
import Image from '../Image';

export default function StaticFocusFilter({
    filter,
    locale,
    selectedFocuses,
    currentPath,
    mobile,
}: {
    filter: {
        id: string;
        icon: string;
        name: {
            en: string;
            fr: string;
        };
    };
    locale: 'en' | 'fr';
    selectedFocuses: string[];
    currentPath: PathEnum.ShortPrograms | PathEnum.Films;
    mobile?: boolean;
}) {
    return (
        <Link
            href={`${currentPath}?${FilterUrlParamEnum.Focuses}=${filter.id}`}
            key={filter.id}
            className="static-image-container flex items-center gap-4 hover:text-primary transition-colors duration-300"
        >
            <Image
                src={filter.icon}
                alt={filter.name[locale]}
                className={`static-image ${selectedFocuses.includes(filter.id) && 'static-image-active'}`}
                fill
            />
            <span
                className={`text-[28px] leading-none uppercase ${selectedFocuses.includes(filter.id) && 'text-primary'} ${mobile && 'text-[22px]'}`}
            >
                {filter.name[locale]}
            </span>
        </Link>
    );
}
